export default "__VITE_ASSET__Dd3Kta0v__"